'use client';

type LoaderPageProps = {
  text?: string;
};

export default function LoaderPage({ text }: LoaderPageProps) {
  return (
    <div className='flex h-screen w-full items-center justify-center'>
      <div className='flex flex-col items-center justify-center'>
        <div className='loader h-12 w-12 animate-spin rounded-full border-4 border-primary'></div>
        <h1 className='mt-6 text-xl font-bold'>{text || 'Loading...'}</h1>
      </div>
    </div>
  );
}
